<template lang="pug">
    .card

        .content(v-if="addressModel.id")
            i.right.floated.link.pencil.icon(v-tooltip="'Adresse ändern'" v-on:click="showModal()")
            .header {{ headline }}

            .meta
                router-link.ui.link(target='_blank' v-bind:to='routerLink') {{ addressModel.name }}

            .description
                .ui.list
                    .item {{ addressModel.firm }}
                    .item {{ addressModel.street }}
                    .item {{ addressModel.zip }} {{ addressModel.city }}

        .content(v-else)
            i.right.floated.link.pencil.icon(v-tooltip="'Adresse ändern'" v-on:click="showModal()")
            .header {{ headline }}
            .description
                i Keine Adresse angegeben

        modal(ref="modal")
            span(slot="header") Adresse ändern

            div(slot="content").ui.form
                address-dropdown-field(
                    v-bind:address-models='optionModels'
                    v-bind:company-model='companyModel'
                    v-bind:country-models='countryModels'
                    v-bind:force-billing-address='forceBillingAddress'
                    v-bind:force-correspondence-address='forceCorrespondenceAddress'
                    v-bind:person-models='personModels'
                    v-model="id"
                )

            action-row(
                slot="footer"
                v-on:cancel="cancel()"
                v-on:save="save()"
            )

</template>

<script>
    import * as R from 'ramda'
    import store from '@/store'
    import * as AddressUtils from '@/utils/address'
    import ActionRow from '@/components/form/ActionRow.vue'
    import AddressDropdownField from '@/components/addresses/DropdownField'
    import AddressUpdateForm from '@/components/addresses/UpdateForm'
    import Modal from '@/components/app/Modal.vue'

    // noinspection ReservedWordAsName
    export default {

        components: { ActionRow, AddressDropdownField, AddressUpdateForm, Modal },

        computed: {

            id: {
               get() { return R.defaultTo({}, this.model).id  },
               set(addressId) {
                   this.model = store.getters['addresses/byId'](addressId)
               }
            },

            optionModels() {
                const processBillingAddresses = () => R.compose(
                    R.map(AddressUtils.format_name_by_default_billing_address),
                    AddressUtils.sort_by_is_default_billing_address
                )(this.addressModels)

                const processCorrespondenceAddresses = () => R.compose(
                    R.map(AddressUtils.format_name_by_default_correspondence_address),
                    AddressUtils.sort_by_is_default_correspondence_address
                )(this.addressModels)

                return R.cond([
                    [R.equals('billing'), processBillingAddresses],
                    [R.equals('correspondence'), processCorrespondenceAddresses],
                    [R.T, R.always(this.addressModels)]
                ])(this.type)

            },

            routerLink() {
                return {
                    name: 'addresses/update',
                    params: { id: this.addressModel.id }
                }
            },

        },

        created() {
            this.model = { ...this.addressModel }
        },

        data() {
            return { model: {} }
        },

        methods: {
            cancel() {
                this.$refs.modal.close()
            },

            save() {
                this.$refs.modal.close()
                this.$emit('save', this.model)
            },

            showModal() {
                this.$refs.modal.show()
            }
        },

        props: {

            addressModel: {
                type: Object,
                required: true
            },

            addressModels: {
                type: Array,
                required: true
            },

            companyModel: {
                type: Object,
                required: true
            },

            countryModels: {
                type: Array,
                required: true
            },

            forceBillingAddress: {
                type: Boolean,
                default: false
            },

            forceCorrespondenceAddress: {
                type: Boolean,
                default: false
            },

            headline: {
                type: String,
                required: true
            },

            isNullable: {
                type: Boolean,
                default: false
            },

            personModels: {
                type: Array,
                required: true
            },

            type: {
                type: String
            }

        }

    }

</script>
